(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/prolongation/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/prolongation/assets/javascripts/prescript.js');

'use strict';

svs.eurojackpot = svs.eurojackpot || {};
svs.eurojackpot.components = svs.eurojackpot.components || {};
svs.eurojackpot.components.prolongation = svs.eurojackpot.components.prolongation || {};
svs.eurojackpot.components.prolongation.views = svs.eurojackpot.components.prolongation.views || {};

 })(window);